import Reveal from "@/components/Reveal";

const PHOTOS = [
  { src: "/images/hero.jpg", caption: "Lezione pratica con l'insegnante", big: true },
  { src: "/images/corso-base.jpg", caption: "L'aula del corso base" },
  { src: "/images/web-design.jpg", caption: "Al lavoro sul laptop" },
  { src: "/images/livello.jpg", caption: "Si impara insieme" },
  { src: "/images/intro.jpg", caption: "Sorrisi in aula" },
  { src: "/images/insegnanti.jpg", caption: "Guidati passo passo" },
  { src: "/images/corso-base-full.jpg", caption: "Imparare divertendosi" },
  { src: "/images/web-design-full.jpg", caption: "Collaborazione al computer" },
];

export default function PhotoGallery() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8" data-testid="gallery-section">
      <Reveal>
        <p className="font-plex text-xs uppercase tracking-[0.28em] text-[#1F8296]">Galleria</p>
        <h2 className="text-balance mt-4 max-w-2xl font-display text-3xl font-semibold tracking-tight text-[#1A2E33] sm:text-4xl">
          L'atmosfera dei nostri corsi
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#5C7178] sm:text-base">
          Piccoli gruppi, un computer e tanta voglia di imparare: ecco come si svolgono le nostre lezioni.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.src} delay={0.05 * i} className={p.big ? "col-span-2 row-span-2" : ""}>
            <figure className="group relative h-full overflow-hidden rounded-3xl border border-[#D8E5E8]">
              <img
                src={p.src}
                alt={p.caption}
                className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${p.big ? "aspect-square md:h-full" : "aspect-square"}`}
                loading="lazy"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0C2930]/85 to-transparent px-5 pb-4 pt-10 text-sm font-semibold text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                {p.caption}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
